import RootStore from '@App/stores/root-store'
import { action, makeObservable, observable, runInAction } from 'mobx'
import { getNotificationToken } from '@App/api/routes/notification'

export default class NotificationStore {
    private _notificationToken: string
    private rootStore: RootStore

    constructor(rootStore: RootStore) {
        makeObservable<NotificationStore, '_notificationToken'>(this, {
            _notificationToken: observable,
            clearNotificationToken: action,
        })
        this.rootStore = rootStore
        this._notificationToken = ''
    }

    get notificationToken(): string {
        return this._notificationToken
    }

    async getNotificationToken() {
        const response = await getNotificationToken()
        runInAction(() => (this._notificationToken = response.data.value))
    }

    clearNotificationToken() {
        this._notificationToken = ''
    }
}
